
import { Button } from "@/components/ui/button";
import { ArrowRight, Clock, BrainCircuit } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";

const SolutionActionSpotlight = () => {
  return (
    <section className="py-16 px-4 bg-white dark:bg-gray-900">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">
            Coming Soon: Solutions & Actions
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            NationCard™ is developing powerful new tools to transform insights into real-world impact
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Solution Cards */}
          <Card className="overflow-hidden border-2 border-nation-purple/20">
            <CardHeader className="bg-nation-purple/5 pb-4">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold text-nation-purple">Solution Cards</h3>
                <div className="flex items-center bg-nation-purple/10 text-nation-purple px-2 py-1 rounded text-xs">
                  <Clock className="h-3 w-3 mr-1" /> Coming Soon
                </div>
              </div>
              <p className="text-sm text-muted-foreground">Collaborative problem-solving</p>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-md mb-4 flex items-center justify-center overflow-hidden">
                <img 
                  src="/img/solution-cards-preview.png" 
                  alt="Solution Cards Preview" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = "https://placehold.co/600x400?text=Solution+Cards";
                  }}
                />
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Solution Cards will capture community-proposed fixes to civic problems. Users will be able to submit, vote on, and implement solutions together.
              </p>
              <ul className="text-sm space-y-1 mb-4">
                <li>• Community-sourced solutions</li>
                <li>• Expert validation process</li>
                <li>• Track implementation progress</li>
                <li>• Measure real-world impact</li>
              </ul>
            </CardContent>
            <CardFooter className="bg-gray-50 dark:bg-gray-800/50">
              <div className="w-full flex items-center justify-center p-2 text-nation-purple">
                <BrainCircuit className="h-5 w-5 mr-2" />
                <span className="text-sm font-medium">In Development</span>
              </div>
            </CardFooter>
          </Card>
          
          {/* Action Cards */}
          <Card className="overflow-hidden border-2 border-nation-teal/20">
            <CardHeader className="bg-nation-teal/5 pb-4">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold text-nation-teal">Action Cards</h3>
                <div className="flex items-center bg-nation-teal/10 text-nation-teal px-2 py-1 rounded text-xs">
                  <Clock className="h-3 w-3 mr-1" /> Coming Soon
                </div>
              </div>
              <p className="text-sm text-muted-foreground">Turn insights into impact</p>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-md mb-4 flex items-center justify-center overflow-hidden">
                <img 
                  src="/img/action-cards-preview.png" 
                  alt="Action Cards Preview" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = "https://placehold.co/600x400?text=Action+Cards";
                  }}
                />
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Action Cards will transform ideas into concrete civic engagement. They'll provide steps, resources, and coordination for community initiatives.
              </p>
              <ul className="text-sm space-y-1 mb-4">
                <li>• Clear action steps</li>
                <li>• Resource coordination</li>
                <li>• Team building tools</li>
                <li>• Success tracking metrics</li>
              </ul>
            </CardContent>
            <CardFooter className="bg-gray-50 dark:bg-gray-800/50">
              <div className="w-full flex items-center justify-center p-2 text-nation-teal">
                <BrainCircuit className="h-5 w-5 mr-2" />
                <span className="text-sm font-medium">In Development</span>
              </div>
            </CardFooter>
          </Card>
        </div>
        
        <div className="mt-10 text-center">
          <Button asChild className="bg-nation-purple hover:bg-nation-purple-dark text-white">
            <Link to="/cards/KY">
              Explore Current Platform <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SolutionActionSpotlight;
